/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { memo, useMemo } from 'react';
import { Box } from '@apia/theme';
import { TResponsiveTableCellRendererProps } from '../types';

const NoMemoNoEllipsisCellRenderer = React.forwardRef<
  HTMLTableCellElement,
  TResponsiveTableCellRendererProps
>(
  (
    {
      cell: { Renderer, rendererProps, AccordionRenderer, ariaLabel, ...cell },
      column,
      row,
      ...props
    },
    currentRef,
  ) => (
    <Box
      as={'td' as any}
      sx={useMemo(
        () => ({
          '&.colored': {
            background: cell.background,
            color: cell.color,
            fontWeight: 'bold',
          },
        }),
        [cell.background, cell.color],
      )}
      ref={currentRef as React.RefObject<HTMLTableCellElement>}
      {...props}
      {...cell}
      aria-label={ariaLabel as string}
    >
      {props.children ?? cell.children}
    </Box>
  ),
);
NoMemoNoEllipsisCellRenderer.displayName = 'DefaultCellRenderer';
export const NoEllipsisCellRenderer = memo(NoMemoNoEllipsisCellRenderer);
